export const formValidators = ['alpha', 'number', 'required', 'email', 'url', 'range', 'objectId']



//////////////////
// WEBPACK FOOTER
// ./config/formConfig.js
// module id = null
// module chunks = 